export const APP_NAME = 'BackOffice';
